import { render, staticRenderFns } from "./ValidateMessage.vue?vue&type=template&id=167ba91c&scoped=true"
import script from "./ValidateMessage.vue?vue&type=script&lang=js"
export * from "./ValidateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ba91c",
  null
  
)

export default component.exports